export default __webpack_public_path__ + "2371374513945af00e2bbc4e3a8582aa.svg";